<template>
  <div>
    <v-row>
      <v-col cols="4">
        <v-text-field
          label="Фамилия"
          outlined
          v-model.trim="v.lastName.$model"
          :errorMessages="getValidationErrorText(v.lastName)"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Имя"
          outlined
          v-model.trim="v.firstName.$model"
          :errorMessages="getValidationErrorText(v.firstName)"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Отчество (при наличии)"
          outlined
          v-model.trim="v.patronymic.$model"
          :errorMessages="getValidationErrorText(v.patronymic)"
        />
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model="v.snils.$model"
          :errorMessages="getValidationErrorText(v.snils)"
          :label="FieldLabel.SNILS"
          :disabled="v.mrpDisabled.$model.includes(FieldName.SNILS)"
          v-mask="Mask.SNILS"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          :label="FieldLabel.INN"
          v-mask="Mask.INN"
          :disabled="v.mrpDisabled.$model.includes(FieldName.INN)"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="v.email.$model"
          :errorMessages="getValidationErrorText(v.email)"
          label="Адрес электронной почты"
          outlined
        />
      </v-col>
    </v-row>

    <MrpaTrustee
      :v="v.trustee"
      label="Сведения о представителе физического лица"
    />
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators';
import {
  getValidationErrorText,
  EMAIL,
  MAX_LENGTH,
  MAX_LENGTH_EMAIL,
  MinLength,
  INN,
  PERSON_NAME,
} from '@/utils/validate';
import cloneDeep from 'clone-deep';
import MrpaTrustee, {
  mrpaTrusteeModel,
  getMrpaTrusteeValidation,
} from '@/components/services/elements/MrpaTrustee';
import { FieldLabel, FieldName, Mask } from '@/constants';

export const personModel = {
  lastName: '',
  firstName: '',
  patronymic: '',

  snils: '',
  inn: '',
  email: '',

  trustee: cloneDeep(mrpaTrusteeModel),
  mrpDisabled: [],
};

export const getPersonValidation = (person) => ({
  lastName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  firstName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  patronymic: {
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },

  snils: {
    required,
    minLength: minLength(MinLength.SNILS),
  },
  inn: {
    required,
    minLength: minLength(12),
    INN: INN(12),
  },
  email: {
    required,
    EMAIL,
    maxLength: maxLength(MAX_LENGTH_EMAIL),
  },

  trustee: getMrpaTrusteeValidation(person.trustee),
  mrpDisabled: {},
});

export default {
  name: 'Person',
  components: {
    MrpaTrustee,
  },
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    FieldLabel,
    FieldName,
    Mask,
    getValidationErrorText,
  }),
};
</script>
